<template>
<div>
  <el-cascader
   :props="props"
    clearable
    placeholder="请选择地址"
    v-model="value"
    :options="options"
    size="mini"
    @change="handleChange"></el-cascader>

 </div>
</template>



<script>
import {addressUrl} from '../../utils/global'
import axios from 'axios'
import Qs from 'qs'
let list
let id=0
  export default {
    props: {
      address: Array    
    },
    data() {
      return {
        value: [],
        options:[],
        props:{
           lazy: true,
           checkStrictly: true,
           lazyLoad (node, resolve) {
            list=JSON.parse(sessionStorage.getItem("list"))
            
            
            const { level } = node;
            let pams='';
            let n=0;
            let l=level;
            if(list.group){
               l=level+6
               pams=list.group.split(",")[0]
              // let nodeArr=[{
              //    value:list.group.split(",")[0]+","+list.group.split(",")[1],
              //    label:list.group.split(",")[1],
              //    leaf: level >= n
              // }]
              //  const nodes = nodeArr
              //  resolve(nodes);
            }
            else{
            if(list.village){
              pams=list.village.split(",")[0]
              n=0
              l=level+5
              // let nodeArr=[{
              //    value:list.village.split(",")[0]+","+list.village.split(",")[1],
              //    label:list.village.split(",")[1],
              //    leaf: level >= n
              // }]
              //  const nodes = nodeArr
              //  console.log(nodes)
              //  resolve(nodes);
              
            }else{  
              if(list.town){
                 n=1
                 pams=list.town.split(",")[0]
                 l=level+4
              }else{
            if(list.country){
                  n=2
                 pams=list.country.split(",")[0]
                 l=level+3
                }else{
                  
              if(list.city){
                    l=level+2
                    n=3
                    pams=list.city.split(",")[0]
                  }else{
                     
                if(list.province){
                      l=level+1
                      n=4
                      pams=list.province.split(",")[0]
                    }else{
                        n=5
                    }
                  }
                }
              }
            }  
            }
         
           if(l==0){
              axios.post(addressUrl+"/query/province").then(function(res){
                let provinceList=res.data.result
                let nodeArr=[]
                for(let i in provinceList){
                  nodeArr.push({
                    value: provinceList[i]['provice_id']+","+provinceList[i]['provice_name'],
                    label: provinceList[i]['provice_name'],
                    leaf: level >= n
                  })
                }
                 
                 const nodes = nodeArr
                 resolve(nodes);
              }).catch(function(){

              })
              }else if(l==1){
              let params={
                 provice_id:node.data?node.data.value.split(",")[0]:pams,
               //  provice_name:node.data.label
              }
              axios.post(addressUrl+"/query/city",Qs.stringify(params),{
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },
                }).then(function(res){
                let provinceList=res.data.result
                let nodeArr=[]
                for(let i in provinceList){
                  nodeArr.push({
                    value: provinceList[i].city_id+","+provinceList[i].city_name,
                    label: provinceList[i].city_name,
                    leaf: level >= n
                  })
                }
                 const nodes = nodeArr
                 
                 resolve(nodes);
              }).catch(function(){

              })
              }else if(l==2){
                let params={
                  city_id:node.data?node.data.value.split(",")[0]:pams,
              }
              axios.post(addressUrl+"/query/county",Qs.stringify(params),{
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },
                }).then(function(res){
                let provinceList=res.data.result
                let nodeArr=[]
                for(let i in provinceList){
                  nodeArr.push({
                    value: provinceList[i].county_id+","+provinceList[i].county_name,
                    label: provinceList[i].county_name,
                    leaf: level >= n
                  })
                }
                const nodes = nodeArr
                 resolve(nodes);
              }).catch(function(){

              })
              }else if(l==3){
                let params={
                 county_id:node.data?node.data.value.split(",")[0]:pams,
              }
             
              axios.post(addressUrl+"/query/town",Qs.stringify(params),{
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },
                }).then(function(res){
                let provinceList=res.data.result
                let nodeArr=[]
                for(let i in provinceList){
                  nodeArr.push({
                    value: provinceList[i].town_id+","+provinceList[i].town_name,
                    label: provinceList[i].town_name,
                    leaf: level >= n
                  })
                }
                 const nodes = nodeArr
                 resolve(nodes);
              }).catch(function(){

              })
              }else if(l==4){
                 let params={
                 town_id:node.data?node.data.value.split(",")[0]:pams,
              }
              axios.post(addressUrl+"/query/village",Qs.stringify(params),{
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },
                }).then(function(res){
                let provinceList=res.data.result
                let nodeArr=[]
                for(let i in provinceList){
                  nodeArr.push({
                    value: provinceList[i].village_id+","+provinceList[i].village_name,
                    label: provinceList[i].village_name,
                    leaf: level >= n
                  })
                }
                 const nodes = nodeArr
                 resolve(nodes);
              }).catch(function(){

              })
              }else if(l==5){
                console.log(pams)
                let params={
                 village_id:node.data?node.data.value.split(",")[0]:pams,
              }
                 axios.post(addressUrl+"/query/group",Qs.stringify(params),{ headers: {
                      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },}).then(function(res){
                let provinceList=res.data.result
                let nodeArr=[]
                for(let i in provinceList){
                  nodeArr.push({
                    value: provinceList[i]['group_id']+","+provinceList[i]['group_name'],
                    label: provinceList[i]['group_name'],
                    leaf: level >= n
                  })
                }
                
                 const nodes = nodeArr
                 
                  resolve(nodes);
              }).catch(function(){

              })
              }else{
                resolve([]);
              }
              
          }
        }
      };
        
      
    },
    watch:{
      address(){
        if(this.address.length>0){
          this.value=this.address
          console.log(this.address) 
        }
      }
    },
    methods: {
      handleChange(value,flag) {
        let avv;
        let bvv;
        avv=value
         if(list.group){
avv=[list.province,list.city,list.country,list.town,list.village,list.group]
         }else{
        if(list.village){
           let a=[list.province,list.city,list.country,list.town,list.village]
           avv=a.concat(value)
        }else{
          if(list.town){
            let a=[list.province,list.city,list.country,list.town]
            avv=a.concat(value)
          }else{
            if(list.country){
            let a=[list.province,list.city,list.country]
           avv=a.concat(value)
          }else{
            if(list.city){
            let a=[list.province,list.city]
            avv=a.concat(value)
          }else{
            if(list.province){
            let a=[list.province]
            avv=a.concat(value)
          }
          }
          }
          }
        }
        }
      let nm=0
       let zl=JSON.parse(sessionStorage.getItem("list"))
       for(var l in zl){
         if(zl[l]){
           nm++
         }
       }
       let target
       
       target = avv.filter(current => {
          return current !== 's' && current !== undefined;
        })
        this.$emit('childByValue', target,nm,flag)
        console.log(target)
      },

    },
    mounted(){
     this. handleChange(["s"],"flag")
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/Core/candode.vue